
export function setAccountsFrom(state, accounts_from) {
    state.accounts_from = accounts_from
}

export function setAccountsUp(state, accounts_up) {
    state.accounts_up = accounts_up
}

export function settrial_balance(state, trial_balance) {
    state.trial_balance = trial_balance
}
export function setParams(state, params){
    state.params = params
}

export function setLevels (state, levels){
  state.levels = levels
}

export function set_balance_account_contact(state, set_balance_account_contact) {
    state.balance_account_contact = set_balance_account_contact
}

export function setdocument_balance_account_contact(state, balance_account_contact_document) {
    state.balance_account_contact_document = balance_account_contact_document
}

export function setSubscriber(state, subscriber){
    state.subscriber = subscriber
}


// WEBPACK FOOTER //
// ./src/modules/trial-balance/mutations.js